var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLtc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9349 12.0002C23.9349 18.5927 18.5908 23.9371 11.9983 23.9371C5.40577 23.9371 0.0615234 18.5927 0.0615234 12.0002C0.0615234 5.40776 5.40577 0.0635166 11.9983 0.0635166C18.5907 0.0635166 23.9349 5.40776 23.9349 12.0002Z",
    fill: "#929CAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3005 15.189L12.0759 12.2696L13.9115 11.599L14.368 9.88321L14.3525 9.84065L12.5456 10.5008L13.8474 5.59867H10.1553L8.45274 11.996L7.03123 12.5153L6.56152 14.2841L7.98195 13.7653L6.97851 17.5355H16.8048L17.4348 15.189H11.3005Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLtc);
export default __webpack_public_path__ + "static/media/ic_ltc.e52ffe6e.svg";
export { ForwardRef as ReactComponent };